const puzzle = {
  id: "9Dd2s3501IysbdlZvjvO",
  name: "A Journey Never Finished",
  rebuses: [
    {
      id: "7f6a7fdf-bb3e-4b8b-8bb0-5d2a0567bf01",
      style: {},
      solutionInfo: {
        solvedText: "Southampton",
        possibleSolutions: [
          {
            id: "409270f0-a5f4-4099-8f57-37fbe09a1d23",
            value: "Southampton",
          },
        ],
        type: "text",
      },
      clues: [
        {
          dependsOn: [],
          subtext: "",
          clueValues: [
            {
              subtext: "~ 110km(68 mi)",
              id: "b6000552-b2ed-49c0-86d4-949b1d2bae6c",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "London",
            },
          ],
          helperText: "Distance from London to that location.",
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          id: "c65db888-695a-4038-bfd0-68cf086f0647",
        },
        {
          clueGroup: 0,
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          style: {
            width: "calc(33% - 10px)",
          },
          helperText: "Distance from Swindon to that location.",
          clueValues: [
            {
              subtext: "~ 76km(47 mi)",
              id: "d129bae8-6725-418b-bd94-2f0be2d4089c",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "Swindon",
            },
          ],
          id: "58a09273-b6d6-4333-86c1-378a391dcb53",
          subtext: "",
          dependsOn: [],
        },
        {
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "13eda7ea-1deb-4eeb-938d-228715bb49a1",
          clueValues: [
            {
              id: "9359a99b-7220-4b88-81ec-69d8e95296af",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "~ 38km(24 mi)",
              value: "Bournemouth",
              type: "text",
            },
          ],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          dependsOn: [],
          clueGroup: 0,
          helperText: "Distance from Bournemouth to that location.",
        },
        {
          helperText: "",
          style: {
            width: "calc(100% - 10px)",
          },
          clueValues: [
            {
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "fa9adba3-8ddd-425e-91ad-8fe1b21a2892",
              value: "RL7Vmm5S.png",
            },
          ],
          subtext: "",
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          id: "04e91e18-7cc4-4995-992d-2745826d0ce7",
          clueGroup: 0,
        },
      ],
    },
    {
      id: "792a97b2-cbce-4cd6-9de2-2f48fc732d7c",
      style: {},
      solutionInfo: {
        possibleSolutions: [
          {
            value: "Cherbourg",
            id: "a28443a9-c71e-4c5c-adb8-8e340d0f8ab4",
          },
          {
            id: "967cc66b-b51a-4d6f-9350-b427397871c3",
            value: "Cherbourg-en-Cotentin",
          },
          {
            value: "Cherbourg-Octeville",
            id: "4733be6d-fdf2-471d-a2c6-bef92cdbfc92",
          },
        ],
        type: "text",
        solvedText: "Cherbourg",
      },
      clues: [
        {
          style: {
            width: "calc(33% - 10px)",
          },
          helperText: "Northern tip of the Cotentin Peninsula",
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          subtext: "",
          clueGroup: 0,
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "Coat of arms",
              type: "image",
              value: "cpXRP5Qq.png",
              id: "e3367d55-f8d4-4f9e-8a2a-417d1423cfe1",
            },
          ],
          id: "5c9e09db-9bab-4282-9577-ef4f81884ebc",
        },
      ],
    },
    {
      style: {},
      clues: [
        {
          clueGroup: 0,
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "64dbffa4-c76b-4beb-94de-3861d427a976",
                value: "Cobh",
              },
            ],
            solvedText: "Cobh",
          },
          helperText: "Find a town whose coat of arms has this Latin phrase",
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          clueValues: [
            {
              value: "Statio Fidissima Classi",
              type: "text",
              subtext: "Town",
              id: "acf69b7a-1897-4afb-a0d4-434c3b0d285f",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "0a8d97ef-8d64-4467-8661-6119d485d31a",
        },
        {
          dependsOn: [
            {
              value: "0a8d97ef-8d64-4467-8661-6119d485d31a",
              id: "f9cbd9e7-1b34-47bc-b487-9538c026f668",
            },
          ],
          subtext: "",
          helperText: "",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              subtext: "",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "64778a91-011d-44c6-b709-eb4bb4e25a1f",
              value: "1849. - 1920.",
            },
          ],
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          id: "68ff2bb2-e799-4755-8c67-c8aa1f23e4e2",
        },
      ],
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            value: "Queenstown",
            id: "35fb029d-fc2e-4a1b-9e98-239bdeef5717",
          },
        ],
        solvedText: "Queenstown",
      },
      id: "d94c316e-6460-481a-85fa-27a075f42ce2",
    },
    {
      clues: [
        {
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "O23OuFfN.png",
              subtext: "",
              id: "7bd0af0b-6981-4e9f-9b0a-b0b50c6bba29",
              type: "image",
            },
          ],
          helperText:
            "This is a route of a famous ship that never made it to New York.",
          clueGroup: 0,
          id: "f772d901-ce5d-47c1-aee7-1067abd5e771",
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          subtext: "",
          dependsOn: [],
          style: {
            width: "calc(100% - 10px)",
          },
        },
      ],
      style: {},
      solutionInfo: {
        solvedText: "Titanic",
        type: "text",
        possibleSolutions: [
          {
            value: "Titanic",
            id: "f961c0c7-0f37-4bfe-9ba3-246fa29c629f",
          },
        ],
      },
      id: "01ebc4a5-0ca0-4a66-8f65-284492bdaf30",
    },
  ],
};
export default puzzle;
